import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ShareSurveyAccessDialogData } from '../dialogs-data/share-survey-access-dialog-data';
import { ShareSurveyAccessDialogComponent } from '../dialogs/share-survey-access-dialog/share-survey-access-dialog.component';

@Injectable()
export class ShareSurveyAccessDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<ShareSurveyAccessDialogComponent>;

    open(shareSurveyAccessDialogData: ShareSurveyAccessDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = ['share-survey-access-dialog-panel'];

        matDialogConfig.width = '900px';
        matDialogConfig.maxWidth = 'calc(100vw - 48px)';

        matDialogConfig.height = '90vh';
        matDialogConfig.maxHeight = '90vh';

        matDialogConfig.data = shareSurveyAccessDialogData;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = true;

        this.matDialogRef = this.dialog.open(ShareSurveyAccessDialogComponent, matDialogConfig);
    }
    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
